import Vue from "vue";

export const EVENT_BUS = new Vue();
